export enum State {
  LOADING = 'loading',
  WARNING = 'warning',
}
